import { useState } from "react";
import { url } from "../utils/config";
import Input from "../reusable_components/Input";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import {
  btnCancel,
  btnOne,
  inputStyle,
  label,
  modalContainer,
  modalTitle,
} from "../utils/style";
import patchData from "../custom_functions/patchData";

function UpdateGlobalConfig(props) {
  const [formData, setFormData] = useState({ ...props.data });
  const [missingFields, setMissingFields] = useState([]);
  const [inputErrors, setInputErrors] = useState([]);
  const [showInputError, setShowInputError] = useState(false);

  const requiredFields = ["value"];

  function updateFormData(e) {
    const { name, value } = e.target;
    console.log(e.target.customField);

    // For date field, limit to 10 characters
    // if (name === "date" && value.length > 10) return;
    // For 'value' field, allow only numbers and dot


    const data = { ...formData }
    console.log(data.name);
    data[name] = value;

    if (data.name === "defaultTax" || data.name === "maxDiscount") {
      const regex = /^(\d{0,2})(\.\d{0,2})?$/;
      if (!regex.test(value)) return;
    }

    if (data.name === "defaultTechnicianCost") {
      const regex = /^(\d{0,3})(\.\d{0,2})?$/;
      if (!regex.test(value)) return;
    }

    if (data.name === "maxEstimateImageSize" || data.name === "estimateExpirationDay" || data.name === "importRowsLimit") {
      const regex = /^\d*$/;
      if (!regex.test(value)) return;
    }



    setFormData(data);
  }

  function updateConfig() {
    if (formData.name === "maxEstimateImageSize" && formData.value > 10) {
      toast.error("Max estimate image size must be 10MB or less", { autoClose: 3000 });
      return;
    }
    if (formData.name === "importRowsLimit" && (Number(formData.value) > 500 || Number(formData.value) <= 0)) {
      toast.error("Import Rows Limit must can be from 1 to 500", { autoClose: 3000 });
      return;
    }

    if (formData.name === "maxEstimateImageSize" && (Number(formData.value) > 10 || Number(formData.value) <= 0)) {
      toast.error("Max estimate image size must be from 1 to 10 MB", { autoClose: 3000 });
      return;
    }

    if (formData.name === "estimateExpirationDay" && (Number(formData.value) > 30 || Number(formData.value) <= 0)) {
      toast.error("Max estimate expiry day must be from 1 to 30 days", { autoClose: 3000 });
      return;
    }


    if (
      formData.value
    ) {
      patchData(
        `${url}/global_config/${formData.id}`,
        formData,
        (error) => {
          toast.error(error?.response?.data?.message || error.message, {
            autoClose: 3000,
          });
        },
        (data) => {
          toast.success(data.message, { autoClose: 3000 });
          props.setShowForm(false);
          props.reload(1 + Math.random());
        }
      );
    } else {
      console.log(formData);
      let fields = Object.keys(formData);
      let miss = [];
      if (fields.length !== requiredFields.length) {
        requiredFields.forEach((field) => {
          if (!fields.includes(field)) {
            miss.push(field);
          }
        });
      }
      setMissingFields(miss);
      setShowInputError(true);
    }
  }

  return (
    <div className={modalContainer}>
      <div className='bg-white w-2/5 px-8 pt-8 pb-4 rounded-lg'>
        <div className={modalTitle}>Update Global Config</div>
        <div>
          <div className='mt-4 grid grid-cols-3'>
            <label className={label}>Name</label>
            <div className='col-span-2'>
              <Input
                index={0}
                name='name'
                type='text'
                className={inputStyle}
                disabled={true}
                value={
                  formData.name?.includes("Discount") ||
                    formData.name?.includes("Tax")
                    ? formData.name
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (c) => c.toUpperCase())
                      .trim() + " %"
                    : formData.name
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (c) => c.toUpperCase())
                      .trim()
                }
              />
            </div>
          </div>
          <div className='grid grid-cols-3'>
            <label className={label}>Value</label>
            <div className='col-span-2'>
              <Input
                index={1}
                inputErrors={inputErrors}
                setInputErrors={setInputErrors}
                missingFields={missingFields}
                name="value"
                required={true}
                value={formData.value}
                className={inputStyle}
                customField={formData.name}
                placeHolder='Enter Value'
                onChange={(e) => updateFormData(e)}
              />
            </div>
          </div>
          <div className='flex justify-between py-3 px-16 gap-8'>
            <button
              onClick={(e) => props.setShowForm(false)}
              className={btnCancel}
            >
              Cancel
            </button>
            <Button
              clickHandler={(e) => updateConfig()}
              className={btnOne}
              name={"Submit"}
            />
          </div>
          <div className='text-red-500 font-semibold text-center'>
            {showInputError && "Please fill all the fields as directed!"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateGlobalConfig;
